import React from "react";
import { useSearchParams } from "react-router-dom";
import FaithFirstBanner from "../assets/FaithFirst_Banner.png";

const RedirectPromotion = () => {
  const [searchParams] = useSearchParams();

  const clickId = searchParams.get("clickId") || "";

  const handleClick = () => {
    const promotionUrl =
      `https://url.promotrking.com/landing/subscribe` +
      `?partner=MMMedia` +
      `&service=Faith` +
      `&clickId=${clickId}`;

    window.location.href = promotionUrl;
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "#ffffff",
      }}
    >
      <img
        src={FaithFirstBanner}
        alt="Faith First Banner"
        onClick={handleClick}
        style={{
          width: "350px",
          height: "350px",
          objectFit: "cover",
          cursor: "pointer",
          borderRadius: "12px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
        }}
      />
    </div>
  );
};

export default RedirectPromotion;